/**
 * luanch a download action
 * @param blobUrl
 * @param filename
 */
export function download(blobUrl: string, filename: string) {
  const a = document.createElement('a')
  if (!a.click) {
    throw new Error('[download]: `a.click()` is not supported.')
  }

  a.href = blobUrl
  a.target = '_parent'
  a.style.display = 'none'

  // Use a.download if available. This increases the likelihood that
  // the file is downloaded instead of opened by another PDF plugin.
  if ('download' in a) {
    a.download = filename
  }

  // <a> must be in the document for IE and recent Firefox versions,
  // otherwise .click() is ignored.
  ; (document.body || document.documentElement).appendChild(a)
  a.click()
  a.remove()
}
